import FLAG from 'config/flag.singleton';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

// NOTE: file is meant to provide flags for ignoring code without putting it in a comment
// NOTE: in order to enable tree-shaking instead of default export, use named exports

// REASONING:
// Code in comments isn't validated as the rest of the code base changes.
// So, either delete it or add a flag in this file
// before the flag add explanation and maybe a link to a place with more info

// SEE: https://getslick.slack.com/archives/C017UAPSFJM/p1664460596045579?thread_ts=1664458383.244529&cid=C017UAPSFJM
export const USE_CUSTOM_SETUP = false; // FIXME: hasn't been true since beginning of 2022, remove it

// SEE: https://getslick.slack.com/archives/C7XSD44GN/p1664885676390279
// Code might be useful for the second expected phase of this ticket.
export const USE_CALLSYNC_BUTTON = false; // FIXME: hasn't been true since beginning of 2022, remove it

// SEE: https://getslick.atlassian.net/browse/GS-10878
// There is a supplemental / replacement message to be shown, a more generic one
// The original one for in-person show up wasn't checking the error code/status/field while showing up in PayPopUp
export const USE_OLD_CARD_PAYMENT_ERROR = false; // FIXME: hasn't been true since beginning of 2023, remove it

// SEE: https://getslick.atlassian.net/browse/GS-13279
// Some Segment related init is done automatically though the 3rd party library, so switch on/off double work through this flag
export const USE_SEGMENT_AND_UPSCOPE = false;

// just an off switch for a very spammy cross-cutting logger
export const USE_LOGGER_SCHEDAY = fromAnyToBool(FLAG.loggerSpam);
